export function chunkArray<T>(items: readonly T[], chunkSize: number): T[][] {
  if (!Number.isInteger(chunkSize) || chunkSize < 1) {
    throw new Error(`chunkSize must be an integer >= 1 (received: ${chunkSize})`)
  }

  const chunks: T[][] = []
  for (let i = 0; i < items.length; i += chunkSize) {
    chunks.push(items.slice(i, i + chunkSize))
  }
  return chunks
}

export function uniquePreserveOrder<T>(items: readonly T[]): T[] {
  const seen = new Set<T>()
  const unique: T[] = []
  for (const item of items) {
    if (seen.has(item)) continue
    seen.add(item)
    unique.push(item)
  }
  return unique
}
